import React, {useEffect, useRef, useState} from "react";
import './user-profile.css';
import {useDispatch} from "react-redux";
import {createUser} from "../../store/slices/userProfileCreated";
import {useNavigate} from "react-router-dom";
import RoutesToPages from "../../assets/RoutesToPages/Routes";
import ServerRequest from "../../ServerRequests/ServerRequest";
import HandleLocalData from "../../modules/HandleLocalData";
import {ReactComponent as UserProfileMainImg} from './img-user-profile/main-img.svg';
import {ReactComponent as UserProfileMaleImg} from './img-user-profile/male-img.svg';
import {ReactComponent as UserProfileFemaleImg} from './img-user-profile/female-img.svg';
// import ServerRequest from "../../ServerRequests/ServerRequest";
// import Loader from "../../components/Loader/Loader";

const UserProfile = () => {
  const pencilImgNameRef = useRef(null);
  const pencilImgWeightRef = useRef(null);
  const [inputNameValue, setInputNameValue] = useState('');
  const [inputWeightValue, setInputWeightValue] = useState('');
  const errorNameRef = useRef(null);
  const [errorName, setErrorName] = useState('');
  const errorWeightRef = useRef(null);
  const [errorWeight, setErrorWeight] = useState('');
  const errorGenderRef = useRef(null);
  const [errorGender, setErrorGender] = useState('');
  const inputNameRef = useRef(null);
  const inputWeightRef = useRef(null);
  const maleGenderRef = useRef(null);
  const femaleGenderRef = useRef(null);
  const userProfileContainerRef = useRef(null);
  const timerFadeIn = useRef(null);
  const phoneNumber = sessionStorage.getItem("phoneNumber") ?? "Unknown";
  // const [loading, setLoading] = useState(false);
  // const loaderRef = useRef(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();


  useEffect(() => {
    if (userProfileContainerRef.current) {
      userProfileContainerRef.current.classList.add('user-profile-fade-in');
    }

    timerFadeIn.current = setTimeout(() => {
      userProfileContainerRef.current.classList.remove('user-profile-fade-in');
    }, 350)

    return () => {
      clearTimeout(timerFadeIn.current)
    }
  }, []);


  const handleChangeName = (e) => {
    setInputNameValue(e.target.value);
  }


  const handleBlur = () => {
    window.scrollTo({top: 0, behavior: 'smooth'});
  };


  useEffect(() => {
    const isWord = /^[a-zA-Z]+(?:[- ][a-zA-Z]+)*$/.test(inputNameValue);
    // const isWord = /^[a-zA-Z]*$/.test(inputNameValue);

    if (!isWord && inputNameValue !== '') {
      setErrorName('Please enter only letters');
      pencilImgNameRef.current.src = require('./img-user-profile/edit-pencil-invalid.svg').default;
      inputNameRef.current.classList.add('invalid-name', 'invalid-name-error');
    } else {
      setErrorName('');
      inputNameRef.current.classList.remove('invalid-name', 'invalid-name-error');
      pencilImgNameRef.current.src = require('./img-user-profile/edit-pencil.svg').default;
    }
  }, [inputNameValue]);


  const handleKeyDown = (e) => {
    if (e.key === '+' || e.key === '-') {
      e.preventDefault(); // блокує введення
    }
  };


  const handleChangeWeight = (e) => {
    let value = e.target.value;

    if (value.includes('+') || value.includes('-')) {
      e.target.value = value.replace(/[+-]/g, ''); // видаляє + і -
    }

    // Видаляємо все, крім цифр
    value = value.replace(/[^0-9]/g, '');

    // Видаляємо початковий нуль, якщо він є
    if (value.startsWith('0')) {
      value = value.slice(1);
    }

    // Обмеження до 3 цифр
    if (value.length <= 3) {
      setInputWeightValue(value);
    }
  };


  useEffect(() => {
    if (inputWeightValue !== '' && inputWeightValue < 10) {
      setErrorWeight("Your weight can\'t be less then 10");
      pencilImgWeightRef.current.src = require('./img-user-profile/edit-pencil-invalid.svg').default;
      inputWeightRef.current.classList.add('invalid-name', 'invalid-name-error');
    } else {
      setErrorWeight('');
      inputWeightRef.current.classList.remove('invalid-name', 'invalid-name-error');
      pencilImgWeightRef.current.src = require('./img-user-profile/edit-pencil.svg').default;
    }
  }, [inputWeightValue]);


  const handleChooseGender = (e) => {
    if (e.target.classList.contains('male')) {
      maleGenderRef.current.classList.add('chosen-gender');
      maleGenderRef.current.classList.remove('unselected-gender');
      femaleGenderRef.current.classList.remove('chosen-gender', 'unselected-gender');
    } else if (e.target.classList.contains('female')) {
      femaleGenderRef.current.classList.add('chosen-gender');
      femaleGenderRef.current.classList.remove('unselected-gender');
      maleGenderRef.current.classList.remove('chosen-gender', 'unselected-gender');
    }
    setErrorGender('');
  }

  const handleSubmitProfileData = async (e) => {
    e.preventDefault();

    let isValid = true; // flag for define that form is valid

    if (inputNameValue === '' || inputNameRef.current.classList.contains('invalid-name')) {
      setErrorName('Please enter only letters');
      pencilImgNameRef.current.src = require('./img-user-profile/edit-pencil-invalid.svg').default;
      inputNameRef.current.classList.add('invalid-name', 'invalid-name-error');
      isValid = false;
    } else {
      setErrorName('');
      pencilImgNameRef.current.src = require('./img-user-profile/edit-pencil.svg').default;
      inputNameRef.current.classList.remove('invalid-name', 'invalid-name-error');
    }

    if (inputWeightValue === '' || inputWeightValue < 10) {
      setErrorWeight("Your weight can\'t be less then 10");
      pencilImgWeightRef.current.src = require('./img-user-profile/edit-pencil-invalid.svg').default;
      inputWeightRef.current.classList.add('invalid-name', 'invalid-name-error');
      isValid = false;
    } else {
      setErrorWeight('');
      pencilImgWeightRef.current.src = require('./img-user-profile/edit-pencil.svg').default;
      inputWeightRef.current.classList.remove('invalid-name', 'invalid-name-error');
    }

    if ((!maleGenderRef.current.classList.contains('chosen-gender') &&
        !femaleGenderRef.current.classList.contains('chosen-gender')) ||
      (maleGenderRef.current.classList.contains('chosen-gender') &&
        femaleGenderRef.current.classList.contains('chosen-gender'))) {
      maleGenderRef.current.classList.add('unselected-gender');
      femaleGenderRef.current.classList.add('unselected-gender');
      setErrorGender('Please choose your gender');
      isValid = false;
    } else {
      maleGenderRef.current.classList.remove('unselected-gender');
      femaleGenderRef.current.classList.remove('unselected-gender');
      setErrorGender('')
    }

    if (isValid) {
      let dataGender = '';
      const phoneNumber = localStorage.getItem('phoneNumber');
      console.log(phoneNumber)

      if (maleGenderRef.current.classList.contains('chosen-gender')) {
        dataGender = maleGenderRef.current.dataset.gender;
      } else if (femaleGenderRef.current.classList.contains('chosen-gender')) {
        dataGender = femaleGenderRef.current.dataset.gender;
      }

      // setLoading(true);
      try {
        const response = await ServerRequest.authorizeUserProfile(
          inputNameValue,
          dataGender,
          inputWeightValue,
          phoneNumber
        );
        const parsedData = await response.json();
        console.log(parsedData)

        const userID = parsedData.userProfileData.userHash;
        localStorage.setItem('userHash', userID);

        if (parsedData.status === 200) {
          try {
            HandleLocalData.prepareAndStoreUserData(parsedData);
          } catch (error) {
            console.error('Error parsing:', error);
          }

          dispatch(createUser({inputNameValue, dataGender, inputWeightValue}));
        }
      } catch (error) {
        console.error("Failed to fetch response");
      } finally {
        // setLoading(false);
      }

      navigate(RoutesToPages.mainPage);
    } else {
      console.log('Form is invalid');
    }
  }


  // test flow
  // /* ******************************************************** */
  //
  // const getSubscriptionData = async () => {
  //   navigate(RoutesToPages.account);
  // }
  //
  // /* ******************************************************** */

  const getSubscriptionData = async () => {
    const subscriptionUserData = await ServerRequest.getMyAccountUserData(phoneNumber);
    const parsedSubscriptionData = await subscriptionUserData.json();

    if (parsedSubscriptionData.status === 200) {
      sessionStorage.setItem('subscriptionType', parsedSubscriptionData.subscription_type);
      sessionStorage.setItem('nextCharge', parsedSubscriptionData.next_charge);
    }
    navigate(RoutesToPages.account);
  }

  // useEffect(() => {
  //   if (loading) {
  //     loaderRef.current.showLoader();
  //     body.style.overflow = "hidden";
  //   } else {
  //     loaderRef.current.hideLoader();
  //     body.style.overflow = "visible";
  //   }
  // }, [loading]);

  return (
    <div ref={userProfileContainerRef}
         className='user-profile-container'>
      <div className='user-profile-content'>
        <img className="user-profile-logo"
             width='96'
             height='24'
             loading="lazy"
             src={require("./img-user-profile/logo-mini.png")}
             alt='image logo'>
        </img>
        <p className='user-profile-title'>My profile</p>
        <p className='user-profile-subtitle'>Create the profile <br/>to continue</p>
      </div>
      <div className='user-profile-form'>
        <UserProfileMainImg className="user-profile-main-img"/>
        <label className='label-name'
               htmlFor="user-profile-form__name">
          Name:
        </label>
        <div className='user-name-container'>
          <input ref={inputNameRef}
                 type="text"
                 value={inputNameValue}
                 onChange={handleChangeName}
                 onBlur={handleBlur}
                 className='user-profile-form__name'
                 placeholder='Enter name'
                 id='user-profile-form__name'
                 maxLength={25}
                 required
          />
          <div className='edit-pencil-container'>
            <img ref={pencilImgNameRef}
                 loading="lazy"
                 className='edit-pencil-img' src={require('./img-user-profile/edit-pencil.svg').default}
                 alt="pencil image"/>
          </div>
          <p ref={errorNameRef}
             className={`error-name-field ${errorName ? 'show-error-field' : ''}`}>
            {errorName ? errorName : null}
          </p>
        </div>
        <p className='user-gender-title'>Gender:</p>
        <div className='user-gender-container'>
          <div ref={maleGenderRef}
               onClick={handleChooseGender}
               data-gender='male'
               className='user-profile-form__gender male'>
            <UserProfileMaleImg className='male'
                                width='42'
                                height='42'/>
          </div>
          <div ref={femaleGenderRef}
               onClick={handleChooseGender}
               data-gender='female'
               className='user-profile-form__gender female'>
            <UserProfileFemaleImg className='female'
                                  width='42'
                                  height='42'/>

          </div>
          <p ref={errorGenderRef}
             className={`error-name-field ${errorGender ? 'show-error-field' : ''}`}>
            {errorGender ? errorGender : null}
          </p>
        </div>
        <label htmlFor="user-profile-form__weight"
               className='label-weight'>
          Weight:
        </label>
        <div className='user-weight-container'>
          <input ref={inputWeightRef}
                 value={inputWeightValue}
                 onChange={handleChangeWeight}
                 onBlur={handleBlur}
                 onKeyDown={handleKeyDown}
                 className='user-profile-form__weight'
                 placeholder='Enter weight, kg'
                 id='user-profile-form__weight'
                 type="number"
                 max="3"
                 step="1"
                 pattern="[0-9]*"
                 inputMode="numeric"
          />
          <div className='edit-pencil-container'>
            <img ref={pencilImgWeightRef}
                 loading="lazy"
                 className='edit-pencil-img' src={require('./img-user-profile/edit-pencil.svg').default}
                 alt="pencil image"/>
          </div>
          <p ref={errorWeightRef}
             className={`error-weight-field ${errorWeight ? 'show-error-field' : ''}`}>
            {errorWeight ? errorWeight : null}
          </p>
        </div>
        <button onClick={handleSubmitProfileData}
                className='btn-user-profile'>
          Continue
        </button>
        <a className='user-profile__my-account'
           onClick={getSubscriptionData}>
          My account
        </a>
        <span className='terms'
              onClick={() => navigate(RoutesToPages.terms)}>
          Terms and Conditions
        </span>
      </div>
      {/*<Loader ref={loaderRef}/>*/}
    </div>
  )
}

export default UserProfile;